import * as Yup from 'yup';

export const GeneralFilterSchema = Yup.object().shape({

});

export type GeneralFilterDataType = Yup.InferType<typeof GeneralFilterSchema>;

type InitialValues = {

};

export const GeneralFilterSchemaInitialValues: InitialValues = {

};

export interface IGeneralFilterResponse {}

export interface IGeneralFilterRequest {
    status: string;
    role: string;
}
